import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/client/lib/page-title";
import { ensureTenantData } from "@/client/lib/session";
import { NotesScreen } from "@/features/notes/components/notes-screen";
import { notesQuery } from "@/features/notes/notes-query";
import { notesSearch } from "@/features/notes/search";

export const Route = createFileRoute("/_authenticated/$slug/notes")({
  head: async ({ match }) => {
    const { notesCopy } = await import("@/features/notes/copy");
    return {
      meta: [{ title: pageTitle(notesCopy.title, match.context.companyName) }],
    };
  },
  validateSearch: notesSearch,
  loader: ({ context }) => ensureTenantData(context.queryClient, notesQuery),
  component: Notes,
});

function Notes() {
  const { slug } = Route.useParams();
  const { note } = Route.useSearch();
  return <NotesScreen slug={slug} open={note} />;
}
